<template>
  <card class="bg-secondary border mb-0" bodyClasses="p-0">
    <div class="card-header bg-transparent pb-5">
      <div class="text-muted text-center mt-2 mb-3">
        <small>{{ $t("sign-in-with") }}</small>
      </div>
      <div class="btn-wrapper text-center">
        <!-- Single-sign-on -->
        <sso-login :redirectTo="this.redirectPath" />
      </div>
    </div>
    <div class="card-body px-5 pb-5 pt-4">
      <slide-x-left-transition>
        <base-alert type="warning" v-if="error">
          <span class="alert-title text-sm">
            {{ $t("login-attempt-failed") }}
          </span>
          <span class="text-sm">{{ error }}</span>
          <nuxt-link to="/auth/reset-password" class="text-white d-block mt-2">
            <small class="text-warning">{{ $t("forgot-password") }}?</small>
          </nuxt-link>
        </base-alert>
      </slide-x-left-transition>
      <div class="text-center text-muted mb-4">
        <small>{{ $t("sign-in-with-credentials") }}</small>
      </div>
      <form @submit.prevent="handleSubmit()">
        <base-input
          class="mb-3"
          name="Email"
          prepend-icon="ni ni-email-83"
          type="email"
          :placeholder="$t('email')"
          v-model="form.email"
        ></base-input>

        <base-input
          class="mb-3"
          name="Password"
          prepend-icon="ni ni-lock-circle-open"
          type="password"
          :placeholder="$t('password')"
          v-model="form.password"
        ></base-input>

        <base-checkbox v-model="form.remember">
          {{ $t("remember-me") }}
        </base-checkbox>
        <div class="text-center">
          <base-button
            type="primary"
            native-type="submit"
            class="mt-4"
            :loading="isLoading"
            >{{ $t("sign-in") }}</base-button
          >
        </div>
      </form>
    </div>
  </card>
</template>

<script>
import SsoLogin from "@/components/auth/SsoLogin.vue";
import axios from "axios";
import { SlideXLeftTransition } from "vue2-transitions";
import { mapGetters } from "vuex";

export default {
  name: "login-card",
  components: {
    SlideXLeftTransition,
    SsoLogin,
  },
  props: {
    redirectTo: {
      type: String,
      default: "/shop/dashboard",
      description: "Path to redirect user once logged in",
    },
  },
  data() {
    return {
      error: null,
      isLoading: false,
      form: {
        email: "",
        password: "",
        remember: true,
      },
    };
  },
  computed: {
    redirectPath() {
      const redirectParam = this.$route.query.redirectTo;

      if (redirectParam) {
        return redirectParam;
      } else {
        return this.redirectTo;
      }
    },
    ...mapGetters({
      user: "auth/user",
    }),
  },
  methods: {
    async handleSubmit() {
      this.error = "";
      this.isLoading = true;

      // Submit the form
      await axios
        .post("/login", this.form)
        .then(async ({ data }) => {
          // Save the token.
          this.$store.dispatch("auth/saveToken", {
            token: data.token,
            remember: this.form.remember,
          });

          // Fetch the user.
          await this.$store.dispatch("auth/fetchUser");

          // Checking user locale
          if (this.user.locale != this.$i18n.locale) {
            this.$i18n.setLocale(this.user.locale);
            this.$store.dispatch("lang/setLocale", this.user.locale);
          }

          // Redirecting
          this.$router.push(this.redirectPath);
        })
        .catch(({ response: { data } }) => {
          this.isLoading = false;
          if (data.errors.email) {
            this.error = data.errors.email[0];
          }
        });
    },
  },
};
</script>

<style></style>
